import { render, staticRenderFns } from "./CssSlider.vue?vue&type=template&id=a40f5da4&scoped=true&"
import script from "./CssSlider.vue?vue&type=script&lang=js&"
export * from "./CssSlider.vue?vue&type=script&lang=js&"
import style0 from "./CssSlider.vue?vue&type=style&index=0&id=a40f5da4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40f5da4",
  null
  
)

export default component.exports